/**
 * @generated SignedSource<<6f0d66653f0634ccffc0aaafb1656135>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OwnerComputeCredits_info$data = {
  readonly balanceInCredits: string;
  readonly name: string;
  readonly transactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"ComputeCreditsTransactionsList_transactions">;
      };
    }>;
  };
  readonly uid: string;
  readonly " $fragmentSpreads": FragmentRefs<"ComputeCreditsBase_info">;
  readonly " $fragmentType": "OwnerComputeCredits_info";
};
export type OwnerComputeCredits_info$key = {
  readonly " $data"?: OwnerComputeCredits_info$data;
  readonly " $fragmentSpreads": FragmentRefs<"OwnerComputeCredits_info">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OwnerComputeCredits_info",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balanceInCredits",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ComputeCreditsBase_info"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 50
        }
      ],
      "concreteType": "OwnerTransactionsConnection",
      "kind": "LinkedField",
      "name": "transactions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OwnerTransactionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OwnerTransaction",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ComputeCreditsTransactionsList_transactions"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "transactions(last:50)"
    }
  ],
  "type": "OwnerInfo",
  "abstractKey": null
};

(node as any).hash = "a253f5cedf7fe6cdf223a4d55e90c3c3";

export default node;
